import React from 'react';
import { TrendingUp, Palette, Zap } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function BenefitsSection() {
  const benefits = [{
    icon: <TrendingUp className="w-10 h-10 text-[#c9a84c]" data-id="element-52" />,
    title: 'More Calls & Leads',
    desc: 'Conversion-first layout with clear CTAs, click-to-call buttons, and WhatsApp integration. Built to turn visitors into customers.'
  }, {
    icon: <Palette className="w-10 h-10 text-[#c9a84c]" data-id="element-53" />,
    title: 'Agency-Quality Design',
    desc: 'Premium look and feel without the agency price tag. Your business deserves a website that looks like you invested thousands.'
  }, {
    icon: <Zap className="w-10 h-10 text-[#c9a84c]" data-id="element-54" />,
    title: 'Fast Delivery',
    desc: 'Your website delivered fast after we receive your content and requirements. No months of back-and-forth.'
  }];
  return <section id="benefits" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#080808'
  }} data-id="element-55">
      <div className="max-w-6xl mx-auto" data-id="element-56">
        <div className="text-center mb-16 reveal" data-id="element-57">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-58">
            Why Irish Businesses Choose Our €249 Website Package
          </h2>
          <div className="h-1 w-20 bg-[#c9a84c] mx-auto rounded-full" data-id="element-59"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-60">
          {benefits.map((benefit, idx) => <div key={idx} className="group relative p-8 rounded-2xl border border-white/[0.06] hover:border-[#c9a84c]/40 transition-all duration-300 reveal" style={{
          backgroundColor: '#0a0a0a',
          transitionDelay: `${idx * 150}ms`
        }} data-id="element-61">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-62"></div>
              <div className="mb-6 bg-[#c9a84c]/10 w-fit p-4 rounded-xl group-hover:bg-[#c9a84c]/15 transition-colors" data-id="element-63">
                {benefit.icon}
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-64">
                {benefit.title}
              </h3>
              <p className="text-white/70 leading-relaxed" data-id="element-65">{benefit.desc}</p>
            </div>)}
        </div>
      </div>
      <SectionDivider data-id="element-66" />
    </section>;
}